export var EAgreementActionTypes;
(function (EAgreementActionTypes) {
  EAgreementActionTypes["MarketingSubscriptionAccepted"] = "agreement/marketingSubscriptionAccepted";
  EAgreementActionTypes["LicenceAccepted"] = "agreement/licenceAccepted";
})(EAgreementActionTypes || (EAgreementActionTypes = {}));